import { selectPreferredLanguage } from 'tradera-state/language/selectors';
import {
    selectFeedbackItemsIds,
    selectHasTranslatedReview,
    selectIsLoadingFeedbackModel,
    selectTranslatedReviews,
    selectIsTranslateable,
    showLoading
} from 'tradera-state/views/profile/selectors';
import {
    beginLoadingModel,
    beginLoadingTranslatedReviews,
    failedLoadingTranslatedReviews,
    setModel,
    setTranslatedReviews,
    showTranslatedReviews,
    setTranslationOnDemandIsDisabled
} from 'tradera-state/views/profile/reducer';
import {
    fetchProfileModel,
    fetchReviews
} from 'tradera-state/views/profile/api';

export const fetchProfileFeedbackModel = ({
    memberId,
    role,
    rating,
    page
}) => async (dispatch, getState) => {
    const state = getState();

    if (selectIsLoadingFeedbackModel(state)) {
        return;
    }

    dispatch(beginLoadingModel());

    dispatch(
        setModel({
            model: (
                await fetchProfileModel({
                    memberId,
                    role,
                    rating,
                    page
                })
            ).data
        })
    );
};

export const loadAndShowTranslatedReviews = feedbackItemIds => async (
    dispatch,
    getState
) => {
    const state = getState();
    feedbackItemIds = feedbackItemIds
        .filter(id => !selectHasTranslatedReview(id)(state))
        .filter(id => selectIsTranslateable(id)(state));
    if (!feedbackItemIds.length) {
        return;
    }

    const toLanguageCodeIso2 = selectPreferredLanguage(getState())
        .languageCodeIso2;

    if (selectTranslatedReviews(getState()) !== null) {
        dispatch(
            showTranslatedReviews({
                show: true
            })
        );
    }

    if (showLoading(getState()) === true) {
        // translation already loading
        return;
    }

    dispatch(beginLoadingTranslatedReviews());
    try {
        const result = await fetchReviews(feedbackItemIds, toLanguageCodeIso2);
        if (result.data.isTranslationOnDemandDisabled) {
            dispatch(setTranslationOnDemandIsDisabled());
            return;
        }

        dispatch(setTranslatedReviews(result.data));
        dispatch(
            showTranslatedReviews({
                show: true,
                language: toLanguageCodeIso2
            })
        );
    } catch (e) {
        dispatch(failedLoadingTranslatedReviews());
    }
};

export const loadAndShowAllTranslatedReviews = () => async (
    dispatch,
    getState
) => {
    const feedbackItemIds = selectFeedbackItemsIds(getState());
    await dispatch(loadAndShowTranslatedReviews(feedbackItemIds));
};

export const hideTranslatedReviews = () =>
    showTranslatedReviews({ show: false });
